import React from "react";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";
import { JSONObject } from "../../services";
import { LABELS } from "../../constants";
import styles from "../../styles/v2.module.css";

interface DiffViewerProps {
  oldData: JSONObject;
  newData: JSONObject;
  oldTitle?: string;
  newTitle?: string;
  darkMode?: boolean;
}

const lightTheme = {
  variables: {
    light: {
      diffViewerBackground: "#fafbfc",
      addedBackground: "#e6ffec",
      addedColor: "#24292f",
      removedBackground: "#ffebe9",
      removedColor: "#24292f",
      wordAddedBackground: "#abf2bc",
      wordRemovedBackground: "#ffc0c0",
      addedGutterBackground: "#ccffd8",
      removedGutterBackground: "#ffd7d5",
      gutterBackground: "#f6f8fa",
      gutterBackgroundDark: "#f0f0f0",
      highlightBackground: "#fffbdd",
      highlightGutterBackground: "#fff5b1",
      codeFoldGutterBackground: "#dbedff",
      codeFoldBackground: "#f1f8ff",
      emptyLineBackground: "#fafbfc",
    },
  },
};

const darkTheme = {
  variables: {
    dark: {
      diffViewerBackground: "#161b22",
      addedBackground: "#1a4721",
      addedColor: "#c9d1d9",
      removedBackground: "#5c2121",
      removedColor: "#c9d1d9",
      wordAddedBackground: "#2ea043",
      wordRemovedBackground: "#f85149",
      addedGutterBackground: "#2d4a3e",
      removedGutterBackground: "#5c3030",
      gutterBackground: "#21262d",
      gutterBackgroundDark: "#161b22",
      highlightBackground: "#3d3d00",
      highlightGutterBackground: "#4d4d00",
      codeFoldGutterBackground: "#1f3d5c",
      codeFoldBackground: "#1c2d3d",
      emptyLineBackground: "#161b22",
    },
  },
};

export const DiffViewer: React.FC<DiffViewerProps> = ({
  oldData,
  newData,
  oldTitle = LABELS.PREVIOUS,
  newTitle = LABELS.CURRENT,
  darkMode = false,
}) => {
  const oldJson = JSON.stringify(oldData, null, 2);
  const newJson = JSON.stringify(newData, null, 2);

  return (
    <div className={`${styles.diffContainer} ${darkMode ? styles.diffContainerDark : ""}`}>
      <ReactDiffViewer
        oldValue={oldJson}
        newValue={newJson}
        splitView={true}
        useDarkTheme={darkMode}
        leftTitle={oldTitle}
        rightTitle={newTitle}
        compareMethod={DiffMethod.WORDS}
        styles={darkMode ? darkTheme : lightTheme}
      />
    </div>
  );
};
